module.exports = __webpack_public_path__ + "img/icon.3f109a40.png";